import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';

class Builder extends React.Component {
	render() {
		return (
			 <div id="builder" className="height-100">{this.props.children}</div>
		);
	}
}

export default Builder;


// WEBPACK FOOTER //
// ./containers/builder/index.js